import { isSymbolIndexDeferredError } from '../deferred-indexing.js';
import { yieldUntilFileBrowserIdle } from '../../../files/browser/in-flight.js';
import { createCodeNavYieldState, yieldDuringCodeNavWork } from '../../yield-during-work.js';
import { ensureSymbolIndexFileInWorkerHost } from '../build/ensure-symbol-index-file-host.js';
import { symbolIndexFileIsReadyAsync } from '../lifecycle/symbol-index-file-ready.js';
import {
  addPendingSymbolIndexTask,
  clearSymbolIndexHeapIfEmpty,
  latestActiveSequenceByParent,
  pendingSymbolIndexTasks,
  pickNextSymbolIndexTask,
  setSymbolIndexWorkerRunning,
  symbolIndexTaskHeap,
  symbolIndexWorkerRunning,
} from './task-queue-store.js';
import { symbolIndexTaskKey } from './task-queue-types.js';

async function runWorkerLoop(): Promise<void> {
  if (symbolIndexWorkerRunning) return;
  setSymbolIndexWorkerRunning(true);
  try {
    const yieldState = createCodeNavYieldState();
    while (pendingSymbolIndexTasks.size > 0) {
      const task = pickNextSymbolIndexTask();
      if (task == null) break;
      pendingSymbolIndexTasks.delete(symbolIndexTaskKey(task.parentPath, task.filePath));
      await yieldUntilFileBrowserIdle();
      await yieldDuringCodeNavWork(yieldState);
      const latestActiveSequence = latestActiveSequenceByParent.get(task.parentPath);
      if (latestActiveSequence != null && task.sequence != null && task.sequence < latestActiveSequence) {
        continue;
      }
      if (!(await symbolIndexFileIsReadyAsync(task.parentPath, task.filePath))) {
        try {
          await ensureSymbolIndexFileInWorkerHost(task.parentPath, task.filePath);
        } catch (err) {
          if (isSymbolIndexDeferredError(err)) {
            if (addPendingSymbolIndexTask(task)) kickSymbolIndexWorkerLoop();
            continue;
          }
          throw err;
        }
      }
    }
  } finally {
    clearSymbolIndexHeapIfEmpty();
    setSymbolIndexWorkerRunning(false);
    if (pendingSymbolIndexTasks.size > 0) void runWorkerLoop();
  }
}

export function kickSymbolIndexWorkerLoop(): void {
  void runWorkerLoop();
}

/** @deprecated Use {@link kickSymbolIndexWorkerLoop}. */
export function kickSymbolIndexWorker(): void {
  kickSymbolIndexWorkerLoop();
}
